/* EnterView  */
const reveals = document.querySelectorAll(".reveal");
const revealUps = document.querySelectorAll(".reveal-up");
const stagger = document.querySelectorAll(".stagger");

if (reveals.length > 0) {
  enterView({
    selector: ".reveal",
    enter: (el, i) => {
      el.classList.add("entered");
    },
    exit: (el) => {
      el.classList.remove("entered");
    },
    offset: 0.1,
  });
}

if (revealUps.length > 0) {
  enterView({
    selector: ".reveal-up",
    enter: (el, i) => {
      el.classList.add("entered");
    },
    exit: (el) => {
      el.classList.remove("entered");
    },
    offset: 0.1,
  });
}

if (stagger.length > 0) {
  stagger.forEach((el) => {
    el.querySelectorAll(".stagger-child").forEach((e, i) => {
      e.style.setProperty("--animation-order", i);
    });
  });
}

/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName(
  "carousel_product_mobile",
);

window.productSwipers = [];

for (var i = 0; i < swiperContainerP.length; i++) {
  swiperContainerP[i].classList.add("swiperP" + i);

  const swiperPage = swiperContainerP[i].querySelector(".swiper-pagination");

  if (swiperPage) {
    swiperPage.classList.add("pageP" + i);
  }

  var mySwiperP = new Swiper(".swiperP" + i, {
    direction: "horizontal",
    loop: false,
    autoHeight: false,
    slidesPerView: 1,
    speed: 300,
    centeredSlides: true,
    pagination: {
      el: ".pageP" + i,
      clickable: true,
    },
  });

  window.productSwipers.push(mySwiperP);
}

var swiperFeaturedCollection = new Swiper("#featuredCollectionSlider", {
  direction: "horizontal",
  slidesPerView: 1.2,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-featured-collection-button-next",
    prevEl: ".swiper-featured-collection-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 3.3,
      spaceBetween: 20,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      centeredSlides: true,
      loop: true,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      centeredSlides: true,
      loop: true,
    },
  },
});

const announcementSwiper = new Swiper(".announcement-swiper", {
  loop: true,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  speed: 800,
});

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = "active") {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(selector1, selector2, className = "active") {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  ".login__forgot-password-button",
);

forgotPasswordButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    toggleClass(".login__form");
    toggleClass(".forgot-password-form");

    console.log("here", button);
  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);

  if (quantity == "+") {
    Number(formQ.value++);
  } else if (quantity == "-" && formQ.value > 1) {
    Number(formQ.value--);
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector("body").classList.add("js-my-cart-open");
}

/* Details Animator */
const details = document.querySelectorAll("details");

if (details.length) {
  details.forEach((detail) => {
    detail.addEventListener("toggle", function () {
      if (!detail.open) {
        detail.classList.add("closing");

        setTimeout(() => {
          detail.classList.remove("closing");
        }, 390);
      }
    });
  });
}

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */
liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
  if (state.requestType == "add") {
    const form = state.info.initiator;
    let btnInner = "";

    const btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btnInner = btn.innerHTML;
      btn.innerHTML = "追加中";
    }

    subscribeToResult((state) => {
      const btn = form.querySelector('button[type="submit"]');
      if (state.responseData.ok) {
        cartOpen();
      }

      if (btn) {
        setTimeout(() => {
          btn.innerHTML = btnInner;
        }, 300);
      }
    });
  }
});

// Load more button function (collections, search)
function initLoadMore() {
  const buttons = document.querySelectorAll(".js-load-more");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = true;

    button.addEventListener("click", function () {
      const nextUrl = button.dataset.nextUrl;
      const containerSelector = button.dataset.container;

      if (!nextUrl || !containerSelector) return;

      const container = document.querySelector(containerSelector);
      if (!container) return;

      button.classList.add("is-loading");

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newContainer = doc.querySelector(containerSelector);
          const newButton = doc.querySelector(".js-load-more");

          if (newContainer) {
            const temp = document.createElement("div");
            temp.innerHTML = newContainer.innerHTML;

            const newItems = temp.querySelectorAll(".reveal-up");

            newItems.forEach((el) => {
              el.classList.remove("entered");
            });

            while (temp.firstChild) {
              container.appendChild(temp.firstChild);
            }
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            requestAnimationFrame(() => {
              newItems.forEach((el, i) => {
                el.classList.add("entered");
              });
            });
          }
          if (newButton) {
            button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            button.remove();
          }
        })
        .finally(() => {
          button.classList.remove("is-loading");
        });
    });
  });
}

// END OF LOAD MORE BUTTON

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll(".account-nav-link");

  if (!links.length) return;

  links.forEach((link) => link.classList.remove("active"));

  if (pathname === "/account") {
    const sections = document.querySelectorAll(".account-section");

    sections.forEach((section) => section.classList.add("hidden"));

    const currentHash = hash || "#dashboard";
    const sectionId = currentHash.replace("#", "account-");
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove("hidden");
    }

    links.forEach((link) => {
      const hrefHash = link.getAttribute("href").split("#")[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add("active");
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}#dashboard`,
      );
    }
  }

  if (pathname.includes("/account/addresses")) {
    const addressLink = document.getElementById("addresses-link");
    addressLink?.classList.add("active");
  }
}

// Product Recommendations (PDP)
function initProductRecommendations(context = document) {
  const sections = context.querySelectorAll("[data-product-recommendations]");
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.loaded === "true") return;

    const url = section.dataset.url;
    if (!url) return;

    const wrapper = section.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const newSlides = temp.querySelectorAll(
          ".product-recommendations__card",
        );
        if (!newSlides.length) return;

        wrapper.innerHTML = "";

        newSlides.forEach((slide) => {
          wrapper.appendChild(slide);
        });
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        initRecommendationSwiper(section);

        section.dataset.loaded = "true";
      })
      .catch((err) => {
        console.error("Recommendation fetch failed:", err);
      });
  });
}

// Product recommendations swiper
function initRecommendationSwiper(section) {
  const swiperEl = section.querySelector("[data-recommendation-swiper]");
  if (!swiperEl) return;

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  new Swiper(swiperEl, {
    direction: "horizontal",
    slidesPerView: 1.2,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 3.5,
        spaceBetween: 20,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
}

// Collection Filtering //
function initCollectionFacets() {
  const collectionPage = document.querySelector(".js-collection-page");
  if (!collectionPage) return;

  const modal = collectionPage.querySelector("#FiltersModal");
  const openBtn = collectionPage.querySelector(".open-filters");
  const closeBtn = collectionPage.querySelector(".filters-close");
  const overlay = collectionPage.querySelector(".filters-overlay");
  const form = collectionPage.querySelector("#FiltersForm");
  const countEl = collectionPage.querySelector("#ActiveFilterCount");
  const headerCountEl = collectionPage.querySelector(
    "#ActiveFilterCountHeader",
  );
  const applyButton = collectionPage.querySelector(".filter__apply-button");

  if (!modal) return;

  // Open/close modal
  const openModal = () => {
    modal.classList.add("active");
    document.body.classList.add("no-scroll");
  };

  const closeModal = () => {
    modal.classList.remove("active");
    document.body.classList.remove("no-scroll");
  };

  openBtn?.addEventListener("click", openModal);
  closeBtn?.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);
  form?.addEventListener("submit", closeModal);

  // Accordion
  collectionPage.querySelectorAll(".js-accordion-toggle").forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      const group = toggle.closest(".filter-group");
      const options = group?.querySelector(".filter-options");
      options?.classList.toggle("active");
      toggle.classList.toggle("active");
    });
  });

  // checkbox states
  const syncActiveCheckboxes = () => {
    collectionPage
      .querySelectorAll('.filter-options input[type="checkbox"]')
      .forEach((input) => {
        const label = input.closest("label");
        if (!label) return;
        label.classList.toggle("is-active", input.checked);
      });
  };

  collectionPage.addEventListener("change", (e) => {
    const input = e.target;

    if (input.type === "checkbox" || input.type === "radio") {
      const label = input.closest("label");
      label?.classList.toggle("is-active", input.checked);

      // For radios, remove active from siblings
      if (input.type === "radio") {
        const radios = collectionPage.querySelectorAll(
          `input[name="${input.name}"]`,
        );
        radios.forEach((radio) => {
          const l = radio.closest("label");
          l?.classList.toggle("is-active", radio.checked);
        });
      }
    }

    updateFilterCount();
    updateProductCount();
  });

  const updateFilterCount = () => {
    if (!form) return;

    let count = 0;

    const checkedBoxes = form.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    count += checkedBoxes.length;

    const minInput = form.querySelector('input[name*="filter.v.price.gte"]');
    const maxInput = form.querySelector('input[name*="filter.v.price.lte"]');

    if (minInput?.value || maxInput?.value) {
      count += 1;
    }

    const formatted = count > 0 ? `(${count})` : "";

    if (countEl) countEl.textContent = formatted;
    if (headerCountEl) headerCountEl.textContent = formatted;
  };

  const updateProductCount = async () => {
    if (!form || !applyButton) return;

    const url = new URL(form.action, window.location.origin);
    const params = new URLSearchParams();

    // Checkboxes
    form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
      params.append(input.name, input.value);
    });

    // Radios
    form.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      params.append(input.name, input.value);
    });

    // Price range
    const minInput = form.querySelector('input[name*="filter.v.price.gte"]');
    const maxInput = form.querySelector('input[name*="filter.v.price.lte"]');

    if (minInput?.value) {
      params.append(minInput.name, minInput.value);
    }

    if (maxInput?.value) {
      params.append(maxInput.name, maxInput.value);
    }

    try {
      const response = await fetch(`${url.pathname}?${params.toString()}`);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const countEl = doc.querySelector(".collection__filter-number");
      const productCount = countEl?.textContent.match(/\d+/)?.[0] || 0;

      applyButton.textContent = `商品を${productCount}件表示`;
    } catch (error) {
      console.error("Error fetching product count:", error);
    }
  };

  syncActiveCheckboxes();
  updateFilterCount();
}

// Search Filtering //
function initSearchFacets() {
  const searchPage = document.querySelector(".js-search-page");
  if (!searchPage) return;

  const modal = searchPage.querySelector("#SearchFiltersModal");
  const openBtn = searchPage.querySelector(".open-filters");
  const closeBtn = modal?.querySelector(".filters-close");
  const overlay = searchPage.querySelector("[data-search-filters-overlay]");
  const form = searchPage.querySelector("#SearchFiltersForm");

  if (!modal || !openBtn) return;

  const openModal = () => {
    modal.classList.add("active");
    document.body.classList.add("no-scroll");
  };

  const closeModal = () => {
    modal.classList.remove("active");
    document.body.classList.remove("no-scroll");
  };

  openBtn.addEventListener("click", openModal);
  closeBtn?.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);
  form?.addEventListener("submit", closeModal);

  searchPage.querySelectorAll(".js-accordion-toggle").forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      const group = toggle.closest(".filter-group");
      const options = group?.querySelector(".filter-options");
      options?.classList.toggle("active");
      toggle.classList.toggle("active");
    });
  });

  searchPage.addEventListener("change", (e) => {
    const input = e.target;
    if (input.type === "radio") {
      const label = input.closest("label");
      label?.classList.toggle("is-active", input.checked);
      searchPage.querySelectorAll(`input[name="${input.name}"]`).forEach((radio) => {
        const l = radio.closest("label");
        l?.classList.toggle("is-active", radio.checked);
      });
    }
  });
}

// Announcement bar
function initAnnouncementBar() {
  const body = document.body;
  const bar = document.getElementById("announcement-bar");

  if (!bar) return;

  bar.classList.remove("hidden-by-default");
  body.classList.add("announcement-bar-visible");
}

function initFaqLinks() {
  const faqLinksSection = document.querySelector(".js-faq-links");
  if (!faqLinksSection) return;

  const links = faqLinksSection.querySelectorAll(".faq-links__link");
  if (!links.length) return;

  const linkMap = {};

  links.forEach((link) => {
    const id = link.dataset.anchor;
    if (id) {
      linkMap[id] = link;
    }
  });

  const observerOptions = {
    root: null,
    rootMargin: "-30% 0px -70% 0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const id = entry.target.id;
      const activeLink = linkMap[id];
      if (!activeLink) return;

      links.forEach((l) => l.classList.remove("active"));
      activeLink.classList.add("active");
    });
  }, observerOptions);

  Object.keys(linkMap).forEach((id) => {
    const targetSection = document.getElementById(id);
    if (targetSection) {
      observer.observe(targetSection);
    }
  });
}

function initGeoModal() {
  const modal = document.getElementById("geo-modal");
  if (!modal) return;

  if (localStorage.getItem("geoModalSeen")) return;

  setTimeout(() => {
    modal.classList.add("active");
  }, 1200);

  function closeModal() {
    modal.classList.remove("active");
    localStorage.setItem("geoModalSeen", "true");
  }

  modal.querySelectorAll(".js-welcome-modal-close").forEach((btn) => {
    btn.addEventListener("click", () => {
      localStorage.setItem("geoModalSeen", "true");
      closeModal();
    });
  });

  const newsletterInput = modal.querySelector(".footer__newsletter-input");
  if (newsletterInput) {
    const placeholder = newsletterInput.getAttribute("placeholder") || "";
    newsletterInput.addEventListener("focus", () => {
      newsletterInput.setAttribute("placeholder", "");
    });
    newsletterInput.addEventListener("blur", () => {
      if (!newsletterInput.value.trim()) {
        newsletterInput.setAttribute("placeholder", placeholder);
      }
    });
  }
}

function initCurrencySelectors() {
  const selectors = document.querySelectorAll(".currency-selector");
  if (!selectors.length) return;

  selectors.forEach((selector) => {
    const form = selector.closest("form");
    const insideModal = selector.closest("#geo-modal");

    resizeCurrencySelector(selector);

    selector.addEventListener("change", () => {
      resizeCurrencySelector(selector);

      if (insideModal) {
        form.dataset.currencyChanged = "true";
        return;
      }

      form.submit();
    });
  });
}

function submitCurrencyIfChanged() {
  const modal = document.getElementById("geo-modal");
  const form = modal?.querySelector("form");

  if (form && form.dataset.currencyChanged === "true") {
    form.submit();
  }
}

function resizeCurrencySelector(selector) {
  let temp = selector._tempMeasure;

  if (!temp) {
    temp = document.createElement("span");
    temp.style.visibility = "hidden";
    temp.style.position = "absolute";
    temp.style.whiteSpace = "nowrap";
    temp.style.font = window.getComputedStyle(selector).font;

    document.body.appendChild(temp);
    selector._tempMeasure = temp;
  }

  const text = selector.options[selector.selectedIndex].text;
  temp.textContent = text;

  const textWidth = temp.offsetWidth;

  const style = window.getComputedStyle(selector);
  const padding =
    parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

  const buffer = 24;

  selector.style.width = textWidth + padding + buffer + "px";
}

// Init functions
window.addEventListener("hashchange", handleAccountPageNav);

document.addEventListener("DOMContentLoaded", function () {
  initLoadMore();
  handleAccountPageNav();
  initProductRecommendations();
  initCollectionFacets();
  initSearchFacets();
  initAnnouncementBar();
  initGeoModal();
  initCurrencySelectors();
});

document.addEventListener("shopify:section:load", (event) => {
  initProductRecommendations(event.target);
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
});
